<template lang="pug">
  .agreements-and-rules(:class="ca_ncsa_present ? 'preview-height' : ''")
    ca_modal_partial(:show="ca_modal.show" :registration_id="registration_id" :organization_id="organization_id" :program_id="program_id" @close="ca_modal.show=false; selected=null" @close_success="ca_modal.show=false" event_id="registration" ca_ncsa_present="ca_ncsa_present" :program_name="program_name" :org_name="org_name" :ncsa_modal_data="ncsa_modal_data")
    .row
      .columns(:class="ca_ncsa_present ? 'large-12 ca-content' : 'large-24'")
        article.content-block
          header(:class="ca_ncsa_present ? 'ca-height' : ''")
            .title
              |{{t('app.college_advisor.ca_block_title')}}
          section.content
            validation-provider(v-slot="{ errors }" rules="required")
              .row.ncsa_promo
                .columns.large-24
                  img(:class="ca_ncsa_present ? 'ca_logo-margin' : ''" class="college_advisor_logo" alt='CA Logo' :src="CAlogo")
                  .ncsa_promo_text
                    p(v-html="t('app.college_advisor.promo2')")
                .columns.large-24
                  p.radio-promo(v-html="t('app.college_advisor.promo3')")
                  .field.checkbox-field2
                    label(for="ca_yes"  :class="{error: errors[0]}")
                      input(type="radio" v-model="selected" :value="true" id="ca_yes" class="no-custom")
                      span.label-text {{t('app.college_advisor.answer1')}}
                  br
                  .field.checkbox-field2
                    label(for="ca_no"  :class="{error: errors[0]}")
                      input(type="radio" v-model="selected" :value="false" id="ca_no" class="no-custom")
                      span.label-text {{t('app.college_advisor.answer2')}}


</template>

<script>
import CAlogo from 'images/CollegeAdvisorLogoNew.png'
import ca_modal_partial from '../../shared/college_advisor_modal'
export default {
  name: "college_advisor_block",
  components: {ca_modal_partial},
  props: ['program_id', 'organization_id', 'registration_id', 'ca_ncsa_present', 'program_name', 'org_name'],
  data(){
    return {
      CAlogo,
      selected: null,
      ca_modal: {
        show: false,
      },
      ncsa_modal_data: null
    }
  },
  watch:{
    selected(){
      this.ncsa_modal_data = this.state.current_reg.registration_form_blocks;
      if (this.selected){this.ca_modal.show = true}
    }
  }

}
</script>
<style scoped lang="scss">
.ncsa_logo{
  width: 150px;
  display: inline-block;
  float:left;
}
.ncsa_promo_text{
  @media (max-width: 768px) {
    width:100%;
  }
  @media only screen and (min-width: 820px) and (max-width: 1180px) { 
    width: 100%;
  }
  display:inline-block;
  width:71%;
  padding-top:5px;
  font-size: 14px !important;
}
.radio-promo{
  margin-bottom: 5px;
  font-weight: 600;
}
.ncsa_promo{
  color: #05101a;
  .label-text{
    font-weight: 100;
  }
}
.college_advisor_logo{
  width: 130px;
  display: inline-block;
  float:left;
}
.preview{
  .preview-height{
      margin-top: -340px;      
    }
}
.parallel-div-ca{
  display: inline-block;
  vertical-align: top;
  width: 40%;
  //margin-right: 15rem;
}
</style>
